import { Assets } from "../../../../../../assets"
import style from "./style.module.scss"

interface OperationFolderCardProps {
    title: string,
    countMediaFiles?: number,
    onClick: () => void,
}

function OperationFolderCard({title, countMediaFiles, onClick}: OperationFolderCardProps) {
  return (
    <div className={style.card__elements}>
        <div className={style.card__items}>
            <img src={Assets.images.operationFile} className=""/>
            <span className={`mt-2 ${style.card__title}`}>{title}</span>
            {countMediaFiles !== undefined && (
            <span className={`mt-2 ${style.card__count_media_files}`}>
                {countMediaFiles}
            </span>
            )}
        </div>
        <img src={Assets.images.eye} className={style.card__eye_button} onClick={onClick}/>
    </div>
  )
}

export default OperationFolderCard